var map = {
	"./add-banner.jpg": 3283,
	"./app-store-banner.jpg": 4403,
	"./app-store.png": 570,
	"./background.jpg": 1831,
	"./banner-slider-10.jpg": 9113,
	"./banner-slider-12.jpg": 3083,
	"./banner-slider-9.jpg": 973,
	"./bg-grocery-2.jpg": 9237,
	"./bg-grocery-4.jpg": 9547,
	"./blog-1.jpg": 6273,
	"./blog-2.jpg": 486,
	"./blog-3.jpg": 8899,
	"./g-11.png": 5841,
	"./g-12.png": 5946,
	"./g-14.png": 6380,
	"./g-19.png": 7033,
	"./google-play.png": 5499,
	"./gp-4.png": 5729,
	"./icons8-laptop-alert-64.png": 5922,
	"./icons8-no-image-96.png": 6417,
	"./img404.png": 4124,
	"./logo.png": 3222,
	"./logotxt.png": 5348,
	"./no-products.jpg": 157,
	"./payments.jpg": 5714,
	"./side-banner-4.jpg": 628,
	"./star.png": 9155,
	"./user-1.png": 6176,
	"./user-2.png": 7467,
	"./user-3.png": 6338,
	"./user.png": 3058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;